import React from "react";
import { inject, observer } from "mobx-react";
import { Rnd } from "react-rnd";
import { Glyphicon } from "react-bootstrap";
import { Link } from "react-router-dom";

const Box = ({ datas, setShowDetails, typeSelected }) => (
  <div
    style={{
      borderRadius: "inherit",
      minWidth: "300px",
      maxHeight: "600px",
      height: "100%",
      padding: "20px",
      boxSizing: "border-box",
      backgroundColor: "white",
      justifyContent: "center",
      overflowY: "scroll",
      whiteSpace: "pre-line",
    }}
  >
    {typeSelected !== "edge" && (
      <Link to={`/view/Cube/${datas?.id.split("-")[0]}/`} target="_blank">
        <Glyphicon glyph="new-window" />
      </Link>
    )}

    <button
      type="button"
      className="closeCubeDetail"
      onClick={() => {
        setShowDetails(false);
      }}
    >
      <span>&times;</span>
    </button>
    {datas?.title}
  </div>
);

@inject("http", "searchStore", "graphicalRepresentationStore")
@observer
class CubeDetails extends React.Component {
  render() {
    const {
      activeNode,
      graph,
      setShowDetails,
      showDetails,
      getActiveEdge,
      typeSelected,
    } = this.props.graphicalRepresentationStore;
    const ActiveNodeDetails = graph.nodes.find((node) => {
      return node.id === activeNode;
    });
    const ActiveEdgeDetails = graph.edges.find((edge) => {
      return edge.id === getActiveEdge;
    });
    ActiveNodeDetails?.title.replaceAll("<br>", "\n");
    ActiveEdgeDetails?.title.replaceAll("<br>", "\n");
    return (
      <>
        {showDetails === true && (
          <Rnd
            className="CubeDetailContainer"
            default={{
              x: 5,
              y: 35,
            }}
            bounds="window"
          >
            <Box
              datas={
                typeSelected === "node" ? ActiveNodeDetails : ActiveEdgeDetails
              }
              setShowDetails={setShowDetails}
              typeSelected={typeSelected}
            ></Box>
          </Rnd>
        )}
      </>
    );
  }
}

export default CubeDetails;
